import React, { Component } from 'react';

class CostRegionCell extends Component {
    render() {
        const value = this.props.dataItem.CostRegion;
        if (value) {
            return <td>Yes</td>;
        } else {
            return <td>No</td>;
        }

    }
}

export default CostRegionCell;
